import { render, staticRenderFns } from "./navigation-bars-login.vue?vue&type=template&id=0b0bfc8a&scoped=true"
import script from "./navigation-bars-login.vue?vue&type=script&lang=js"
export * from "./navigation-bars-login.vue?vue&type=script&lang=js"
import style0 from "./navigation-bars-login.vue?vue&type=style&index=0&id=0b0bfc8a&prod&scoped=true&lang=css"
import style1 from "./navigation-bars-login.vue?vue&type=style&index=1&id=0b0bfc8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0bfc8a",
  null
  
)

export default component.exports